export const fulfillmentPolicy = 'Fulfillment Policy';
export const platinumPartners = 'Platinum Partners';
export const privacyPolicy = 'Privacy Policy';
